import { render, staticRenderFns } from "./historic.vue?vue&type=template&id=65948231"
import script from "./historic.vue?vue&type=script&lang=js"
export * from "./historic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports